export default __webpack_public_path__ + "3c1a1302632721d8d74e658c055b9d26.svg";